import { render, staticRenderFns } from "./AddProducer.vue?vue&type=template&id=1e54b02f&scoped=true&"
import script from "./AddProducer.vue?vue&type=script&lang=js&"
export * from "./AddProducer.vue?vue&type=script&lang=js&"
import style0 from "./AddProducer.vue?vue&type=style&index=0&id=1e54b02f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e54b02f",
  null
  
)

export default component.exports